// Preset hand-drawn artwork shipped with the site (served from /public/assets/es).
export const ES_ARTWORK = [
  { file: "eye-hero", label: "עין ראשית" },
  { file: "eye-crying", label: "עין בוכה" },
  { file: "eye-drip", label: "עין זולגת" },
  { file: "eye-pink", label: "עין ורודה" },
  { file: "sym-eye", label: "עין קשת" },
  { file: "sym-heart", label: "לב שכבות" },
  { file: "sym-nazar", label: "נזאר" },
  { file: "faces", label: "פנים" },
  { file: "col-sticker", label: "עין + לב" },
  { file: "col-poster", label: "קופסה סוריאליסטית" },
  { file: "crystalball", label: "כדור בדולח" },
  { file: "heart-sun", label: "לב זוהר" },
  { file: "heart-red", label: "לב אדום" },
  { file: "planet-pink", label: "כוכב ורוד" },
  { file: "planet-turq", label: "כוכב טורקיז" },
  { file: "stars-gold", label: "כוכבי זהב" },
  { file: "sparkle-gold", label: "ניצוץ זהב" },
  { file: "sparkle-turq", label: "ניצוץ טורקיז" },
  { file: "star-heart", label: "כוכב-לב" },
  { file: "bolt", label: "ברק" },
  { file: "hearts-fall", label: "לבבות" },
  { file: "teardrop", label: "דמעה" },
  { file: "cloud", label: "ענן" },
  { file: "prism", label: "פריזמה" },
];

export const artworkPath = (file) => `/assets/es/${file}.webp`;
